import { VehicleAlert } from "features/CenterContent/shared/TilsynAlerts/schema";
import {
  alarmRowOnClick,
  getMappedAlertState,
  getMappedAlertType,
} from "features/CenterContent/shared/TilsynAlerts/utils";
import { DropsButton, TableCell, TableRow, Text } from "shared/components/Spor";
import { formatDateString } from "shared/utils/dateTimeUtils";
import styled, { useTheme } from "styled-components";

const CustomTr = styled(TableRow)`
  &&&:hover {
    filter: ${({ theme }) => theme.filterHover};
  }
  &&& td {
    padding: 9px 18px;
    border: none;
  }
`;

type TilsynAlertRowProps = {
  alert: VehicleAlert;
  fullSize: boolean;
};

const TilsynAlertRow = ({ alert, fullSize = false }: TilsynAlertRowProps) => {
  const theme = useTheme();

  const alertTime = formatDateString(
    alert.createdAt,
    "dd.MM.yyyy HH:mm",
    "Ukjent datoformat",
  );
  const actionTime = alert.inProgressAt
    ? formatDateString(alert.inProgressAt, "dd.MM.yyyy HH:mm")
    : "Ikke påbegynt";

  const getStateColor = () => {
    switch (alert.state) {
      case "DELAYED":
      case "PENDING":
        return {
          fill: theme.colorWarningFillPulse,
          text: theme.colorWarningTextMain,
          border: theme.colorWarningOutline,
        };
      case "ACTIVE":
        return {
          fill: theme.colorAlarmFillPulse,
          text: theme.colorAlarmTextMain,
          border: theme.colorAlarmOutline,
        };
      case "RESOLVE_IN_PROGRESS":
      default:
        return {
          fill: theme.colorBackgroundMain,
          text: undefined,
          border: theme.colorOutlineMain,
        };
    }
  };

  return (
    <CustomTr
      backgroundColor={getStateColor().fill}
      color={getStateColor().text}
      borderBottom={`1px solid ${getStateColor().border}`}
      onClick={() => alarmRowOnClick(alert)}
      cursor="pointer"
    >
      {fullSize && <TableCell>{alert.setId}</TableCell>}
      <TableCell>{alert.vehicleId}</TableCell>
      <TableCell>{alertTime}</TableCell>
      <TableCell>{getMappedAlertType(alert)}</TableCell>
      <TableCell>{actionTime}</TableCell>
      {fullSize && <TableCell>{getMappedAlertState(alert)}</TableCell>}

      {fullSize && (
        <TableCell>
          <DropsButton
            title="Åpne i Tilsyn"
            size="xs"
            variant="tertiary"
            onClick={() => alarmRowOnClick(alert)}
          >
            <Text variant="sm" color={getStateColor().text}>
              Åpne
            </Text>
          </DropsButton>
        </TableCell>
      )}
    </CustomTr>
  );
};

export default TilsynAlertRow;
